import { render, staticRenderFns } from "./area-key-item.component.vue?vue&type=template&id=968541aa&scoped=true&"
import script from "./area-key-item.component.vue?vue&type=script&lang=ts&"
export * from "./area-key-item.component.vue?vue&type=script&lang=ts&"
import style0 from "./area-key-item.component.vue?vue&type=style&index=0&id=968541aa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968541aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
